import { render, staticRenderFns } from "./DetailDeliveryReturnSlit.vue?vue&type=template&id=231ed1e2&scoped=true&"
import script from "./DetailDeliveryReturnSlit.vue?vue&type=script&lang=js&"
export * from "./DetailDeliveryReturnSlit.vue?vue&type=script&lang=js&"
import style0 from "./DetailDeliveryReturnSlit.vue?vue&type=style&index=0&id=231ed1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ed1e2",
  null
  
)

export default component.exports